import axios from "axios";
import React, { useEffect, useState } from "react";
import { translate } from "reducers/i18n";
import settings from "client.settings.json";
import { PageComponent } from "components/page";

const { api } = settings;

const PasswordAuthenticators = (props) => {
  const { messageId, mappings } = props;
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [value, setValue] = useState("");
  const [coolingDown, setCoolingDown] = useState(false);
  const [startCount, setStartCount] = useState(15);
  const [count, setCount] = useState(15);

  useEffect(() => {
    if (!coolingDown) return;
    setCount(startCount);
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setCoolingDown(false);
          setError(null);
          return null;
        }
        return prev - 1;
      });
    }, 60000);
    return () => clearInterval(interval);
  }, [coolingDown]);

  const placeholder = mappings["E_DELIVERY_ENTER_CODE_PAGE_SMS"]?.placeholder?.replace(/<\/?[^>]+(>|$)/g, "") || "";

  const submitPassword = async () => {
    try {
      if (!value) {
        return void setError("_error_password_missing");
      }

      setError("");
      setIsSubmitting(true);
      await axios.post(`${api}/api/login/password`, { messageId, value });
      setValue("");
    } catch (error) {
      const { data, status } = error.response || {};
      const { count, errorcode } = data || {};

      if (status === 429) {
        setStartCount(count || 15)
        setCoolingDown(true);
        setError(errorcode)
        return
        // return void setError(translate(errorcode, count));
      }

      setError(errorcode ? errorcode : error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setError("");
    setValue(e.target.value);
  };

  return (
    <>
      <PageComponent
        noHeader={true}
        content={mappings["E_DELIVERY_LOGIN_PAGE_PASSWORD"]}
        btnFunctions={[() => submitPassword()]}
        disabled={isSubmitting || coolingDown}
        innerStyles={{ display: "flex",
          alignItems: "center",
          gap: ".25rem" }}
      >
        <input
          autoFocus={true}
          className="password"
          onChange={handleChange}
          placeholder={placeholder}
          type="password"
        />
      </PageComponent>
      {error && <div className="error"> {translate(error, (coolingDown ? count : ''))}</div>}
    </>
  );
};

export default PasswordAuthenticators;
